import contract from "./contract";
import files from "./files";

export const employment = {
    contract,
    files,
};

export default employment;
